import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectStaffUserModalComponent } from '../../../modals/select-staff-user-modal/select-staff-user-modal.component';
import { User } from '../../../../../../models/user';


class GenericInstructor {
  // Allow snake_case variables in order to align with API.
  /* tslint:disable:variable-name */
  id: number;
  first_name: string;
  last_name: string;
  is_sub?: boolean;
  /* tslint:enable:variable-name */
}


@Component({
  selector: 'app-edit-event-instructors',
  templateUrl: './edit-event-instructors.component.html',
  styleUrls: ['./edit-event-instructors.component.css']
})
export class EditEventInstructorsComponent {
  @Input() instructors: GenericInstructor[];
  @Input() useIsSub: boolean;
  // Used to ensure the input IDs do not clash when multiple copies of this component are rendered.
  @Input() id: string;

  constructor(
    private modalService: NgbModal
  ) {}

  public openAddInstructor() {
    const modalRef = this.modalService.open(SelectStaffUserModalComponent);
    modalRef.componentInstance.excludeUserIds = this.getInstructorIds();
    modalRef.componentInstance.submitCallback = (result: User) => {
      if (this.getInstructorIds().includes(result.id)) {
        return;
      }

      const newInstructor: GenericInstructor = {
        id: result.id,
        first_name: result.first_name,
        last_name: result.last_name
      };
      if (this.useIsSub) {
        newInstructor.is_sub = false;
      }
      this.instructors.push(newInstructor);
    };
  }

  public moveInstructorUp(instructorIdx: number) {
    if (instructorIdx === 0) { return; }

    [
      this.instructors[instructorIdx - 1],
      this.instructors[instructorIdx]
    ] = [
      this.instructors[instructorIdx],
      this.instructors[instructorIdx - 1]
    ];
  }

  public moveInstructorDown(instructorIdx: number) {
    if (instructorIdx === (this.instructors.length - 1)) { return; }

    [
      this.instructors[instructorIdx + 1],
      this.instructors[instructorIdx]
    ] = [
      this.instructors[instructorIdx],
      this.instructors[instructorIdx + 1]
    ];
  }

  public removeInstructor(instructorIdx: number) {
    this.instructors.splice(instructorIdx, 1);
  }

  private getInstructorIds(): number[] {
    return this.instructors.map(i => i.id);
  }

}
